import React from 'react';
import SubpageLayout from './SubpageLayout';

const cover = (
  <div className="cover cover-shield">
    <svg className="deco" viewBox="0 0 1100 360" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(550 180)" fill="none" stroke="#9A56FF" strokeWidth="2" strokeLinejoin="round">
        <path d="M0 -110 L100 -75 L100 25 C100 75 50 110 0 120 C-50 110 -100 75 -100 25 L-100 -75 Z" opacity="0.85" />
        <path d="M0 -90 L80 -60 L80 20 C80 60 40 90 0 100 C-40 90 -80 60 -80 20 L-80 -60 Z" opacity="0.45" />
        <path d="M-30 -10 L-5 20 L40 -30" strokeWidth="3" />
      </g>
      <g fill="rgba(255,255,255,0.05)">
        <circle cx="180" cy="100" r="2" />
        <circle cx="240" cy="240" r="2" />
        <circle cx="900" cy="120" r="2" />
        <circle cx="860" cy="260" r="2" />
        <circle cx="120" cy="200" r="2" />
        <circle cx="980" cy="200" r="2" />
      </g>
    </svg>
  </div>
);

export default function Privacy() {
  return (
    <SubpageLayout
      docTitle="Privacy — Game Accelerator"
      title="Privacy"
      lede="Your traffic is yours. We can't read your packets, we don't sell your data, and we keep the smallest log we can to keep the network healthy."
      cover={cover}
    >
      <p style={{ color: 'var(--text-3)', fontSize: 14 }}>Last updated: April 12, 2026</p>

      <h2>What we collect</h2>
      <p>To run an account, we need an <strong>email address</strong>, a <strong>device identifier</strong>, and your <strong>billing details</strong> (handled by our payment processor — we never see your card number). To pick a fast route, we need to know which game you're launching and your approximate region. That's it.</p>

      <h2>What we don't do</h2>
      <p>We do not log the contents of your traffic. We don't inspect packets beyond the headers we need to route them, and our tunnels are encrypted end-to-end between your device and our edge. We don't sell, rent, or share your data with advertisers — there are no advertisers, because we charge for the product.</p>

      <h2>Routing telemetry</h2>
      <p>To keep the network healthy, we keep <strong>aggregate</strong> latency, packet loss, and throughput statistics per edge node. These metrics are stripped of any account or device identifier within 24 hours. You can opt out of even this aggregate collection in <em>Settings → Privacy</em>; it doesn't affect your service.</p>

      <h2>Your rights</h2>
      <p>You can export every piece of personal data we hold about you, request deletion, or correct inaccuracies, from your account dashboard. We respond to verified requests within 30 days. If you're in the EU, UK, California, Brazil, or any other jurisdiction with specific data rights — those rights apply, and we honor them globally.</p>

      <h2>Security</h2>
      <p>We use AES-256 for tunnel encryption, hardware security modules for our root keys, and we run continuous third-party penetration testing. If you find a vulnerability, please report it to <a href="#">security@gameaccelerator.gg</a> — we run a paid disclosure program with hall-of-fame credit.</p>

      <h2>Contact</h2>
      <p>Privacy questions go to <a href="#">privacy@gameaccelerator.gg</a>. Our Data Protection Officer responds within five business days.</p>
    </SubpageLayout>
  );
}
